module.exports = {
  "country": "SE",
  "artist": "Måns Zelmerlöw",
  "song": "Heroes",
  "year": "2015",
  "place": "1",
  "spotify": "4ciaNqHWA2IzHphZaVRzHI"
};